import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';

export const appendClassNamesToProps = <T extends IModuleProps | INodeProps>(element: T, classNameToAdd: string): T => {
    return { ...element, className: `${element.className} ${classNameToAdd}` };
};
